import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';

const GetSpruceProjectData = graphql(`
  query GetSpruceProjectData($projectId: ID!) {
    projectById(id: $projectId) {
      canBeLinkedToSpruce {
        result
        reasons {
          code
          message
        }
      }
      addresses {
        site {
          publicId
          energyPerformanceCertificates {
            metadata {
              certificateNumber
            }
          }
          propertyInformation {
            propertyType
            builtForm
            constructionAgeBand
            floorAreaM2
            numBedrooms
            heatingSystem
            heatingEnergyUseKwh
            wallConstruction
            wallInsulation
            windowGlazingType
            loftInsulationMm
            numStoreys
          }
        }
      }
    }
  }
`);

const useGetSpruceProjectData = (projectId: string) => {
  const { data, ...rest } = useQuery({
    queryKey: projectKeys.spruceProjectData(projectId),
    queryFn: () => gqlClient.request(GetSpruceProjectData, { projectId }),
  });

  const project = data?.projectById;
  const siteAddress = project?.addresses.site[0];

  return {
    siteAddress,
    data,
    ...rest,
  };
};

export default useGetSpruceProjectData;
